// extracted by mini-css-extract-plugin
module.exports = {"presenter":"VideoPresenter_presenter__1TSh2","presenterIcon":"VideoPresenter_presenterIcon__2uI9G"};